import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "bazaroo_recent";
const MAX = 20;
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

// "شوهد مؤخراً": last 20 approved ads the visitor opened (newest first), same as the app.
export function recordView(id) {
  if (!id) return;
  localStorage.setItem(KEY, JSON.stringify([id, ...read().filter((x) => x !== id)].slice(0, MAX)));
}

export function useRecentlyViewed() {
  const [ads, setAds] = useState([]);
  useEffect(() => {
    const ids = read();
    if (!ids.length) return;
    api.get("/listings", { params: { ids: ids.join(","), limit: MAX } })
      .then(({ data }) => { const by = Object.fromEntries((data.items || []).map((a) => [a.id, a])); setAds(ids.map((i) => by[i]).filter(Boolean)); })
      .catch(() => {});
  }, []);
  const clear = useCallback(() => { localStorage.removeItem(KEY); setAds([]); }, []);
  return { ads, clear };
}
